import {useQuery} from 'react-query'
 import {ContactEditModalForm} from './ContactEditModalForm'
//  import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
 import {getContactById} from '../core/_requests'
import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'

const ContactEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const dataresponse = {name:"demo"}
  const {
    isLoading,
    data: contact,
    error,
  } = useQuery(
    `${QUERIES.CONTACTS_LIST}-contact-${itemIdForUpdate}`,
    () => {
      return getContactById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
       // setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <ContactEditModalForm isContactLoading={false} contact={{id: undefined}} />
  }

  if (itemIdForUpdate) {
    return <ContactEditModalForm isContactLoading={false} contact={dataresponse} />
  }

  return null
}

export {ContactEditModalFormWrapper}
